import { AppError } from "shared/types/error/AppError"

export class AttachmentCreateError extends AppError {
  constructor(message: string) {
    super(message)
    this.name = "AttachmentCreateError"
  }
}
